export default __webpack_public_path__ + "static/media/no-search-found.4ead4d62.svg";